import React from 'react';
import { Typography } from '@mui/material';
import { tok, MONO } from './ui';

// A surface that shows a backtest number (return, win rate, CAGR…) carries this line beneath it:
// those numbers are simulated, and must never read as a track record (DWLF-534). One wording,
// shared, so the backtest surfaces cannot drift apart; public/llms.txt carries the same text (pinned by
// HypotheticalLegend.test.js).
export const HYPOTHETICAL_LEGEND = 'Hypothetical results: simulated on past data, not actual trading. '
  + 'Simulated results have inherent limitations — they benefit from hindsight and may not reflect costs, '
  + 'slippage or liquidity — and past results do not indicate future results.';

export default function HypotheticalLegend({ sx }) {
  return (
    <Typography data-testid="hypothetical-legend" sx={{ fontFamily: MONO, fontSize: '0.6875rem', lineHeight: 1.5, color: tok('ink-45'), ...sx }}>
      {HYPOTHETICAL_LEGEND}
    </Typography>
  );
}
